/**
 * Open Natter WebSocket Channel Helpers
 */

export interface OpenNatterChannels {
  personal: string;
  broadcast: string;
}

/**
 * Get WebSocket channel destinations for Open Natter
 * @param id - Open Natter event ID
 * @returns Object with personal and broadcast channel destinations
 */
export const getOpenNatterChannels = (id: string): OpenNatterChannels => ({
  personal: `/user/queue/open-natters/${id}`,
  broadcast: `/topic/open-natters/${id}`,
});
